import React from 'react';
import { PageTemplateAlert as BasePageTemplateAlert } from '@sierralabs/core-ui';
import { useWorkflowContext } from '@sierralabs/workflow-ui';
// alert for no workflow or no user permissions
const PageTemplateAlert = props => {
    const { error } = useWorkflowContext();
    const showAlert = !!error;
    return !showAlert ? (React.createElement(React.Fragment, null)) : (React.createElement(BasePageTemplateAlert, Object.assign({}, props, { severity: 'warning' }), error === null || error === void 0 ? void 0 :
        error.message,
        " Please contact your administrator to update the Workflow settings."));
};
export default PageTemplateAlert;
//# sourceMappingURL=PageTemplateAlert.js.map